import { render, staticRenderFns } from "./checkCT.vue?vue&type=template&id=0060eda7&scoped=true"
import script from "./checkCT.vue?vue&type=script&lang=js"
export * from "./checkCT.vue?vue&type=script&lang=js"
import style0 from "./checkCT.vue?vue&type=style&index=0&id=0060eda7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060eda7",
  null
  
)

export default component.exports